import styled from 'styled-components'
import { media, colors, rgba, radiuses } from 'styles'

const StyledPersonal = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 2.7rem;

  ${media.mobile`
    justify-content: center;
  `}

  ${media.phone`
    flex-direction: column;
  `}
`

const StyledPersonalTab = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 1rem 0.5rem;
  font-size: 1.2rem;
  text-transform: uppercase;
  text-decoration: none;
  color: ${rgba(colors.textMain, 0.6)};
  border: 0.2rem solid ${rgba(colors.textMain, 0.1)};
  border-radius: 0 0 ${radiuses.large} ${radiuses.large};
  border-top: none;
  user-select: none;
  &:hover {
    cursor: pointer;
  }
  &.active {
    border-bottom: 0.2rem solid ${colors.textMain};
    color: ${colors.textMain};
    font-weight: 700;
  }
`

const StyledPersonalTabs = styled.div`
  display: flex;
  width: 100%;
`

export { StyledPersonal, StyledPersonalTab, StyledPersonalTabs }
